var map = {
	"./basic_thumb.jpg": 212,
	"./blogpost1.jpg": 3864,
	"./blogpost2.jpg": 6711,
	"./blogpost3.jpg": 4554,
	"./blogpost4.jpg": 297,
	"./blogpost5.jpg": 2300,
	"./card3.jpg": 722,
	"./card4.jpg": 7281,
	"./card5.jpg": 6375,
	"./card6.jpg": 563,
	"./card7.jpg": 5862,
	"./cards_thumb.jpg": 1387,
	"./coloured-card-with-btn.jpg": 9827,
	"./coloured-card.jpg": 4649,
	"./contact1.jpg": 9682,
	"./contact2.jpg": 3837,
	"./content1.jpg": 967,
	"./content4.jpg": 318,
	"./features1.jpg": 9701,
	"./features2.jpg": 2362,
	"./features3.jpg": 1367,
	"./features4.jpg": 7580,
	"./features5.jpg": 4953,
	"./features6.jpg": 8814,
	"./features7.jpg": 5275,
	"./features8.jpg": 368,
	"./harvard.jpg": 2559,
	"./header1.jpg": 2071,
	"./header2.jpg": 7320,
	"./header3.jpg": 837,
	"./header4.jpg": 5838,
	"./linkedin-btn.jpg": 6410,
	"./microsoft.jpg": 4023,
	"./nuk-pro-back-sky.jpg": 1071,
	"./nuk-pro-buildings.png": 4851,
	"./pages2_thumb.jpg": 564,
	"./pricing1.jpg": 7528,
	"./pricing2.jpg": 6404,
	"./pricing3.jpg": 8218,
	"./pricing4.jpg": 3961,
	"./pricing5.jpg": 9612,
	"./projects1.jpg": 4132,
	"./projects2.jpg": 1939,
	"./projects4.jpg": 6589,
	"./projects5.jpg": 5456,
	"./sections_thumb.jpg": 4354,
	"./share-btn.jpg": 3513,
	"./social-row.jpg": 2153,
	"./stanford.jpg": 9944,
	"./table.jpg": 8095,
	"./team1.jpg": 5339,
	"./team2.jpg": 2540,
	"./team3.jpg": 585,
	"./team4.jpg": 9898,
	"./team5.jpg": 3735,
	"./testimonials1.jpg": 1810,
	"./testimonials2.jpg": 765,
	"./testimonials3.jpg": 5200,
	"./vodafone.jpg": 6218,
	"assets/img/presentation-page/basic_thumb.jpg": 212,
	"assets/img/presentation-page/blogpost1.jpg": 3864,
	"assets/img/presentation-page/blogpost2.jpg": 6711,
	"assets/img/presentation-page/blogpost3.jpg": 4554,
	"assets/img/presentation-page/blogpost4.jpg": 297,
	"assets/img/presentation-page/blogpost5.jpg": 2300,
	"assets/img/presentation-page/card3.jpg": 722,
	"assets/img/presentation-page/card4.jpg": 7281,
	"assets/img/presentation-page/card5.jpg": 6375,
	"assets/img/presentation-page/card6.jpg": 563,
	"assets/img/presentation-page/card7.jpg": 5862,
	"assets/img/presentation-page/cards_thumb.jpg": 1387,
	"assets/img/presentation-page/coloured-card-with-btn.jpg": 9827,
	"assets/img/presentation-page/coloured-card.jpg": 4649,
	"assets/img/presentation-page/contact1.jpg": 9682,
	"assets/img/presentation-page/contact2.jpg": 3837,
	"assets/img/presentation-page/content1.jpg": 967,
	"assets/img/presentation-page/content4.jpg": 318,
	"assets/img/presentation-page/features1.jpg": 9701,
	"assets/img/presentation-page/features2.jpg": 2362,
	"assets/img/presentation-page/features3.jpg": 1367,
	"assets/img/presentation-page/features4.jpg": 7580,
	"assets/img/presentation-page/features5.jpg": 4953,
	"assets/img/presentation-page/features6.jpg": 8814,
	"assets/img/presentation-page/features7.jpg": 5275,
	"assets/img/presentation-page/features8.jpg": 368,
	"assets/img/presentation-page/harvard.jpg": 2559,
	"assets/img/presentation-page/header1.jpg": 2071,
	"assets/img/presentation-page/header2.jpg": 7320,
	"assets/img/presentation-page/header3.jpg": 837,
	"assets/img/presentation-page/header4.jpg": 5838,
	"assets/img/presentation-page/linkedin-btn.jpg": 6410,
	"assets/img/presentation-page/microsoft.jpg": 4023,
	"assets/img/presentation-page/nuk-pro-back-sky.jpg": 1071,
	"assets/img/presentation-page/nuk-pro-buildings.png": 4851,
	"assets/img/presentation-page/pages2_thumb.jpg": 564,
	"assets/img/presentation-page/pricing1.jpg": 7528,
	"assets/img/presentation-page/pricing2.jpg": 6404,
	"assets/img/presentation-page/pricing3.jpg": 8218,
	"assets/img/presentation-page/pricing4.jpg": 3961,
	"assets/img/presentation-page/pricing5.jpg": 9612,
	"assets/img/presentation-page/projects1.jpg": 4132,
	"assets/img/presentation-page/projects2.jpg": 1939,
	"assets/img/presentation-page/projects4.jpg": 6589,
	"assets/img/presentation-page/projects5.jpg": 5456,
	"assets/img/presentation-page/sections_thumb.jpg": 4354,
	"assets/img/presentation-page/share-btn.jpg": 3513,
	"assets/img/presentation-page/social-row.jpg": 2153,
	"assets/img/presentation-page/stanford.jpg": 9944,
	"assets/img/presentation-page/table.jpg": 8095,
	"assets/img/presentation-page/team1.jpg": 5339,
	"assets/img/presentation-page/team2.jpg": 2540,
	"assets/img/presentation-page/team3.jpg": 585,
	"assets/img/presentation-page/team4.jpg": 9898,
	"assets/img/presentation-page/team5.jpg": 3735,
	"assets/img/presentation-page/testimonials1.jpg": 1810,
	"assets/img/presentation-page/testimonials2.jpg": 765,
	"assets/img/presentation-page/testimonials3.jpg": 5200,
	"assets/img/presentation-page/vodafone.jpg": 6218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5208;